import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import CommonTableGraph from '../../../../charts/CommonTableGraph';
const HErrorTab = ({ deviceHistory }) => {
    const config = deviceHistory?.errors ?? [];
    let tableFormat = config.map((row) => {
        return {
            Name: row.error,
            State: row.state,
            _Time: row.finishedTime ?? row.startTimestamp,
        };
    });
    if (tableFormat.length === 0)
        tableFormat = [{ Name: 'No errors found', _Time: undefined }];
    return _jsx(CommonTableGraph, { data: tableFormat });
};
export default HErrorTab;
